import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { version } from "../../package.json"
import socialShareImg from "../images/quiz-hero-image.png"

export const QuizSEO = ({ meta }) => {
    return (
        <Helmet
            htmlAttributes={{ lang: "en" }}
            title={meta.metaTitle}
            // titleTemplate={`%s | ${meta.name}`}
            meta={[
                {
                    name: `description`,
                    content: meta?.metaDescription,
                },
                {
                    property: `og:title`,
                    content: meta?.metaTitle,
                },
                {
                    property: `og:description`,
                    content: meta?.shareText,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    property: `og:url`,
                    content: `https://quiz.hiddenremote.com/what-should-i-binge-tv-quiz`,
                },
                {
                    property: `og:image`,
                    content:
                        typeof window !== "undefined"
                            ? window?.location.origin +
                              socialShareImg +
                              "?" +
                              version
                            : "https://quiz.hiddenremote.com/static/quiz-hero-image-feb8ade2a0d4314bc500ec68eea5866b.png",
                },
                {
                    property: `og:image:alt`,
                    content: meta?.metaTitle,
                },
                {
                    property: `og:image:width`,
                    content: 1200,
                },
                {
                    property: `og:image:height`,
                    content: 600,
                },
                {
                    name: `twitter:domain`,
                    content:
                        typeof window !== "undefined"
                            ? window?.location.origin
                            : "",
                },
                {
                    name: `twitter:card`,
                    content: `summary_large_image`,
                },
                {
                    name: `twitter:creator`,
                    content: `@FanSided_ENT`,
                },
                {
                    name: `twitter:title`,
                    content: meta?.name,
                },
                {
                    name: `twitter:site`,
                    content: `@FanSided_ENT`,
                },
                {
                    name: `twitter:description`,
                    content: meta?.shareText,
                },
                {
                    name: `twitter:image`,
                    content:
                        typeof window !== "undefined"
                            ? window?.location.origin +
                              socialShareImg +
                              "?" +
                              version
                            : "https://quiz.hiddenremote.com/static/quiz-hero-image-feb8ade2a0d4314bc500ec68eea5866b.png",
                },
                {
                    name: `twitter:image:src`,
                    content:
                        typeof window !== "undefined"
                            ? window?.location.origin +
                              socialShareImg +
                              "?" +
                              version
                            : "https://quiz.hiddenremote.com/static/quiz-hero-image-feb8ade2a0d4314bc500ec68eea5866b.png",
                },
                {
                    name: `twitter:image:alt`,
                    content: meta?.name,
                },
            ].concat(meta)}
        />
    )
}

QuizSEO.defaultProps = {
    meta: {},
}

QuizSEO.propTypes = {
    meta: PropTypes.shape({
        date: PropTypes.string.isRequired,
        image: PropTypes.shape({
            width: PropTypes.string.isRequired,
            height: PropTypes.string.isRequired,
        }),
        metaTitle: PropTypes.string.isRequired,
        metaDescription: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        shareText: PropTypes.string.isRequired,
        styles: PropTypes.shape({
            darkerColor: PropTypes.string.isRequired,
            lighterColor: PropTypes.string.isRequired,
        }).isRequired,
    }),
}
